export { default } from './App';
export { default as Form } from './Form';



// WEBPACK FOOTER //
// ./src/pages/partners/components/index.js